import React from "react";
import { Modal, Button, Alert, Spinner } from "react-bootstrap";

const DeleteConfirmModal = ({
	show,
	onHide,
	handleDeleteSubmit,
	deleteLoading,
	deleteError,
	eventTitle,
}) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title className="text-danger">
					<i className="bi bi-exclamation-triangle-fill me-2"></i>
					Confirm Deletion
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{deleteError && <Alert variant="danger">{deleteError}</Alert>}
				<p className="lead text-dark fw-medium">
					Are you sure you want to permanently delete the event{" "}
					<strong>"{eventTitle}"</strong>?
				</p>
				<p className="text-dark">
					This action cannot be undone. All event information will be permanently
					removed.
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onHide} disabled={deleteLoading}>
					Cancel
				</Button>
				<Button variant="danger" onClick={handleDeleteSubmit} disabled={deleteLoading}>
					{deleteLoading ? (
						<>
							<Spinner animation="border" size="sm" className="me-2" />
							Deleting...
						</>
					) : (
						<>
							<i className="bi bi-trash-fill me-2"></i>Delete Event
						</>
					)}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteConfirmModal;
